import React from 'react';
import { Clock } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
export function RequestsWidget() {
  const navigate = useNavigate();
  // Mock data
  const pendingRequests = [{
    id: 1,
    type: 'Congé',
    dates: '22 - 31 déc. 2023',
    status: 'pending',
    submittedDate: '15 nov. 2023'
  }, {
    id: 2,
    type: 'Ressource',
    description: 'Accès au logiciel XYZ',
    status: 'processing',
    submittedDate: '10 nov. 2023'
  }];
  return <div className="bg-white rounded-lg shadow-sm p-5 min-h-[400px] flex flex-col" data-id="element-2070">
      <div className="flex items-center justify-between mb-4" data-id="element-2071">
        <h3 className="font-semibold text-gray-900" data-id="element-2072">Mes demandes</h3>
        <Clock className="h-5 w-5 text-blue-600" data-id="element-2073" />
      </div>
      {pendingRequests.length > 0 ? <div className="space-y-4 flex-1" data-id="element-2074">
          {pendingRequests.map(request => <div key={request.id} className="border-l-4 border-yellow-500 pl-3 py-1" data-id="element-2075">
              <div className="flex justify-between items-start" data-id="element-2076">
                <div data-id="element-2077">
                  <p className="font-medium text-gray-900" data-id="element-2078">{request.type}</p>
                  <p className="text-sm text-gray-600" data-id="element-2079">
                    {request.dates || request.description}
                  </p>
                  <p className="text-xs text-gray-500 mt-1" data-id="element-2080">
                    Soumis le {request.submittedDate}
                  </p>
                </div>
                <span className="text-xs px-2 py-1 rounded-full bg-yellow-100 text-yellow-800" data-id="element-2081">
                  {request.status === 'pending' ? 'En attente' : 'En traitement'}
                </span>
              </div>
            </div>)}
        </div> : <div className="text-center py-4 flex-1 flex items-center justify-center" data-id="element-2082">
          <p className="text-gray-500" data-id="element-2083">Aucune demande en cours</p>
        </div>}
      <div className="mt-4 flex justify-between" data-id="element-2084">
        <button onClick={() => navigate('/conges')} className="text-blue-600 text-sm font-medium hover:text-blue-800" data-id="element-2085">
          Historique
        </button>
        <button onClick={() => navigate('/conges')} className="text-blue-600 text-sm font-medium hover:text-blue-800" data-id="element-2086">
          Nouvelle demande
        </button>
      </div>
    </div>;
}